
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/builds/weplaybig/platform/big-front/sentry.client.config.ts")
            }
          });